<script>
export default {
    name: 'FlagGreatBritain'
}
</script>
<template>
    <svg
        class="base-flag flag-great-britain"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        width="28"
        height="20"
        viewBox="0 0 28 20"
    >
        <defs><rect id="a" width="28" height="20" x="0" y="0" rx="2" /></defs>
        <g fill="none" fill-rule="evenodd">
            <mask id="b" fill="#fff"><use xlink:href="#a" /></mask>
            <use fill="#FFF" xlink:href="#a" />
            <path fill="#0A17A7" d="M0 0h28v20H0z" mask="url(#b)" />
            <path
                fill="#FFF"
                d="M29.282-1.916l1.492 2.21-9.449 6.373H28v6.666h-6.675l9.449 6.373-1.492 2.21-11.95-8.06.001 7.477h-6.666v-7.477l-11.95 8.06-1.49-2.21 9.447-6.373H0V6.667h6.674L-2.774.294l1.492-2.21 11.948 8.06v-7.477h6.667v7.477l11.95-8.06z"
                mask="url(#b)"
            />
            <path
                stroke="#DB1F35"
                stroke-linecap="round"
                stroke-width=".667"
                d="M18.668 6.332L31.333-2"
                mask="url(#b)"
            />
            <path
                stroke="#DB1F35"
                stroke-linecap="round"
                stroke-width=".667"
                d="M20.013 21.35l11.354-7.652"
                mask="url(#b)"
                transform="matrix(1 0 0 -1 0 35.048)"
            />
            <path
                stroke="#DB1F35"
                stroke-linecap="round"
                stroke-width=".667"
                d="M8.006 6.31L-3.837-1.671"
                mask="url(#b)"
            />
            <path
                stroke="#DB1F35"
                stroke-linecap="round"
                stroke-width=".667"
                d="M9.29 22.31l-13.127-8.705"
                mask="url(#b)"
                transform="matrix(1 0 0 -1 0 35.915)"
            />
            <path
                fill="#E6273E"
                d="M0 12h12v8h4v-8h12V8H16V0h-4v8H0z"
                mask="url(#b)"
            />
        </g>
    </svg>
</template>
